import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useSidebarOptional } from '../../ui/Sidebar/Sidebar';

interface CustomTriggerProps {
  isCollapsed: boolean;
  className?: string;
  /** When provided, used when sidebar context is unavailable (e.g. TopBar during HMR). */
  toggleSidebar?: () => void;
}

export function CustomTrigger({
  isCollapsed,
  className,
  toggleSidebar: toggleFromProps,
}: CustomTriggerProps) {
  const sidebarContext = useSidebarOptional();
  const toggleSidebar = toggleFromProps ?? sidebarContext?.toggleSidebar ?? (() => {});

  const Icon = isCollapsed ? ChevronsRight : ChevronsLeft;

  return (
    <button onClick={toggleSidebar} className={className}>
      <Icon size={16} className="text-[#212636] rtl:rotate-180" />
    </button>
  );
}
